import { MediumDataKey } from 'modules/templateEditor/common';
import { TextAreaField as TextArea } from 'modules/templateEditor/common/components';
import { useRef } from 'react';
import { EmptyInput, ReadOnlyField, formatLabelForId } from '../../utils';
import { StyledFormField } from './styles';

type Props = {
  isEditMode: boolean;
  label: string;
  restrictionText?: string;
  mediumDataKey: MediumDataKey;
  mediumDataValue: string;
  setMediumDataValue: (value: string) => void;
};

export const TextAreaField = ({
  isEditMode,
  label,
  restrictionText,
  mediumDataKey,
  mediumDataValue,
  setMediumDataValue,
}: Props) => {
  const testTag = `embedded-template-settings-form-${formatLabelForId(label)}`;
  const ReadOnlyContent = mediumDataValue || <EmptyInput />;
  const ref = useRef<HTMLTextAreaElement>(null);

  return (
    <StyledFormField
      data-test={testTag}
      labelText={label}
      restrictionText={restrictionText}
      isHorizontalLayout
    >
      {isEditMode ? (
        <TextArea
          mediumDataKey={mediumDataKey}
          mediumDataValue={mediumDataValue}
          onChangeHandler={setMediumDataValue}
          mediumRef={ref}
        />
      ) : (
        <ReadOnlyField>{ReadOnlyContent}</ReadOnlyField>
      )}
    </StyledFormField>
  );
};
